import countries from 'i18n-iso-countries';

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export const getCountryOptions = () => {
  return Object.entries(countries.getNames('en')).map(([code, name]) => ({
    value: code,
    label: name,
  }));
};
